import { render } from "./Detail.vue?vue&type=template&id=6d2cb9f0"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
script.render = render

export default script